import { fetchWrapper } from '@/helpers'

const ruta = process.env.VUE_APP_ROOT_API

export default class VehiculoService {
  async getVehiculosAll() {
    return await fetchWrapper.get(`${ruta}/vehiculos`)
  }

  async getVehiculosPaginados(params = {}) {
    const query = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''))
    ).toString()
    return await fetchWrapper.get(`${ruta}/vehiculos/paginated?${query}`)
  }

  async sendVehiculoNew(datos) {
    return await fetchWrapper.post(`${ruta}/vehiculos`, datos)
  }

  async updateVehiculo(datos) {
    return await fetchWrapper.put(`${ruta}/vehiculos/${datos.id}`, datos)
  }

  async deleteVehiculo(id) {
    return await fetchWrapper.delete(`${ruta}/vehiculos/${id}`)
  }

  async getVehiculoDatosNecesarios() {
    return await fetchWrapper.get(`${ruta}/vehiculos/datosNecesarios`)
  }

  async getMarcasAll() {
    return await fetchWrapper.get(`${ruta}/marcas`)
  }

  async getModelosAll() {
    return await fetchWrapper.get(`${ruta}/modelos`)
  }

  async saveMarca(datos) {
    return await fetchWrapper.post(`${ruta}/marcas`, datos)
  }

  async updateMarca(datos) {
    return await fetchWrapper.put(`${ruta}/marcas/${datos.id}`, datos)
  }

  async saveModelo(datos) {
    return await fetchWrapper.post(`${ruta}/modelos`, datos)
  }

  async updateModelo(datos) {
    return await fetchWrapper.put(`${ruta}/modelos/${datos.id}`, datos)
  }
}